import { CopyButton, Group, Text, Tooltip, UnstyledButton } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { TbCheck, TbCopy } from 'react-icons/tb'

const CopyableValue = ({ value, monospace = true }: { value?: string | null; monospace?: boolean }) => {
  const { t } = useTranslation('common')

  if (!value) return <Text size="sm">{t('notAvailable')}</Text>

  return (
    <CopyButton value={value} timeout={1500}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? t('copied') : t('copy')} withArrow position="top">
          <UnstyledButton onClick={copy} aria-label={copied ? t('copied') : t('copyValue', { value })}>
            <Group gap={6} wrap="nowrap" align="center">
              <Text size="sm" ff={monospace ? 'monospace' : undefined}>
                {value}
              </Text>
              {copied ? (
                <TbCheck size={14} color="var(--mantine-color-teal-6)" />
              ) : (
                <TbCopy size={14} color="var(--mantine-color-dimmed)" />
              )}
            </Group>
          </UnstyledButton>
        </Tooltip>
      )}
    </CopyButton>
  )
}

export default CopyableValue
